var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM10.897 8.408l.336 4.896h1.536l.336-4.896.08-2.128h-2.368l.08 2.128zm.08 8.368c.278.277.619.416 1.024.416a1.34 1.34 0 0 0 1.008-.416c.278-.288.416-.64.416-1.056 0-.427-.138-.779-.416-1.056a1.315 1.315 0 0 0-1.008-.432c-.405 0-.746.144-1.024.432-.266.277-.4.63-.4 1.056 0 .416.134.768.4 1.056z",
    fill: "#B00020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.7a74ac76ae9e572581ee0a1f7febf11f.svg";
export { ForwardRef as ReactComponent };